import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

const CLOSED = { ctn: false, ctn_beheren: false, ctn_aankoop: false, ctn_verkoop: false };
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function useCtnAccess(userId, firmaId) {
  const { pathname } = useLocation();
  const scope = `${userId}:${firmaId}`;
  const [state, setState] = useState(null);
  useEffect(() => {
    let active = true, sequence = 0;
    const load = async () => {
      const version = ++sequence;
      try {
        const { data } = await axios.get(`${API}/instellingen/mijn-ctn-machtigingen`, { timeout: 10000 });
        if (active && version === sequence) setState({ scope, permissions: data });
      } catch (error) {
        if (active && version === sequence) setState((old) => ({ scope, permissions: !error.response && old?.scope === scope ? old.permissions : CLOSED }));
      }
    };
    const visible = () => { if (document.visibilityState === "visible") load(); };
    load();
    window.addEventListener("focus", load);
    window.addEventListener("online", load);
    window.addEventListener("ctn-access-updated", load);
    document.addEventListener("visibilitychange", visible);
    return () => {
      active = false;
      window.removeEventListener("focus", load);
      window.removeEventListener("online", load);
      window.removeEventListener("ctn-access-updated", load);
      document.removeEventListener("visibilitychange", visible);
    };
  }, [scope, pathname]);
  return { permissions: state?.scope === scope ? state.permissions : CLOSED, ready: state?.scope === scope };
}